import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { diamGridStringFilterOperators } from '../../diamGridUtils';
import {
  RoleContainer,
  RoleDescription,
  RoleName,
} from '../DiamDataGrid/styles';
import { Role } from './types';

export function buildRoleColumns(
  formatDateTime: (dateIso?: string | null) => string,
): GridColDef<Role>[] {
  return [
    {
      field: 'name',
      headerName: 'Role',
      flex: 1.5,
      minWidth: 240,
      filterOperators: diamGridStringFilterOperators,
      valueGetter: (_value, row) => `${row.name}, ${row.description}`,
      renderCell: ({ row }) => (
        <RoleContainer>
          <RoleName>{row.name}</RoleName>
          <RoleDescription title={row.description}>
            {row.description}
          </RoleDescription>
        </RoleContainer>
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Created at',
      flex: 0.9,
      minWidth: 170,
      filterable: false,
      getApplyQuickFilterFn: () => null,
      renderCell: ({ row }) => formatDateTime(row.createdAt),
    },
    {
      field: 'updatedAt',
      headerName: 'Updated at',
      flex: 0.9,
      minWidth: 170,
      filterable: false,
      getApplyQuickFilterFn: () => null,
      renderCell: ({ row }) => formatDateTime(row.updatedAt),
    },
  ];
}
